import { Button, Snackbar } from "@material-ui/core";
import React, { useState } from "react";

import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
} from "@mui/material";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const SocieteInformation = ({
  setOnShowInformationModel,
  informationModel,
}) => {
  const [open, setOpen] = React.useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  // const [openInfoAlert, setOpenInfoAlert] = useState(false);
  // const [infoAlertText, setInfoAlertText] = useState();

  const handleClose = () => {
    setOpen(false);

    setOnShowInformationModel(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  // const handleInfoClose = (event, reason) => {
  //   if (reason === "clickaway") {
  //     return;
  //   }
  //   setOpenInfoAlert(false);
  // };

  return (
    <>
      <Dialog
        open={true}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" align="center">
          {" "}
          <img
            alt="Remy Sharp"
            src={informationModel.image}
            class="rounded-circle"
            style={{ width: "50px", height: "50px" }}
          ></img>
        </DialogTitle>
        <DialogContent align="center">
          <DialogContentText id="alert-dialog-slide-description">
            <div class="card-body">
              <div class="row" style={{ marginTop: -20 }}>
                {/* <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Image: </label>
                  <img
                    alt="Remy Sharp"
                    src={informationModel.image}
                  
                    class="rounded-circle"
                    style={{ width: "50px", height: "50px" }}
                  ></img>
                </div> */}

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Matricule: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {informationModel.matricule}{" "}
                  </label>
                </div>
                
                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Adresse: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {informationModel.adress}{" "}
                  </label>
                </div>
                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Numéro établissement: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {informationModel.nbrEtbl}{" "}
                  </label>
                </div>
                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Code TVA: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",

                      fontFamily: "Garamond",
                    }}
                  >
                    {informationModel.codeTva}{" "}
                  </label>
                </div>
                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Data de création: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {informationModel.creationDate}{" "}
                  </label>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{ marginTop: -20, justifyContent: "space-around" }}
        >
          <Button onClick={handleClose} style={{ color: "red" }}>
            Quitter
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openAlert}
        autoHideDuration={1000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleClose} severity="success">
          Ajout avec success !
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      {/* <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar> */}
    </>
  );
};

export default SocieteInformation;
